package de.katoonerie.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Iframe
import org.w3c.dom.HTMLElement

@Composable
fun YouTubeVideo(videoId: String, title: String, attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null) {
    Div(attrs = {
        classes("relative", "w-full", "p-0", "overflow-hidden", "aspect-video")
        attrs?.invoke(this)
    }) {
        Iframe(attrs = {
            classes("absolute", "top-0", "bottom-0", "left-0", "w-full", "h-full", "border-0")
            attr("title", title)
            attr("src", "https://www.youtube-nocookie.com/embed/$videoId?rel=0&showinfo=0&modestbranding=1")
            attr("allowfullscreen", "allowfullscreen")
        })
    }
}
